import { HttpInterceptorFn } from '@angular/common/http';

const MUTATIONS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

/**
 * Propaga X-Correlation-Id em mutações para join audit ↔ histórico de domínio.
 */
export const correlationInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.includes('/api/v1/')) {
    return next(request);
  }

  if (!MUTATIONS.has(request.method.toUpperCase())) {
    return next(request);
  }

  if (request.headers.has('X-Correlation-Id')) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        'X-Correlation-Id': crypto.randomUUID(),
      },
    }),
  );
};
